import React from 'react';
import styled, { css } from 'styled-components';

import getColorForScore from '~/util/getColorForScore';
import JustificationContainer from '~/components/atom/JustificationContainer';
import TEST_ID from './index.testid';
import getContrastingColor from '~/util/getContrastingColor';
type Props = {
  className?: string;
  leadScore: number;
};

const LeadScoreDisplayer = (props: Props) => {
  const { className, leadScore } = props;

  return (
    <JustificationContainer
      data-testid={TEST_ID.CONTAINER}
      className={className}
      align="center"
      justification="center"
    >
      <CircleContainer $leadScoreToDisplay={leadScore}>
        <LeadScoreSpan data-testid={TEST_ID.SPAN} $leadScore={leadScore}>
          {leadScore}
        </LeadScoreSpan>
      </CircleContainer>
    </JustificationContainer>
  );
};

type CircleContainerProps = {
  $leadScoreToDisplay: number;
};

const CircleContainer = styled.div<CircleContainerProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2em;
  height: 2.2em;
  border-radius: 50%;

  ${({ theme, $leadScoreToDisplay }) => css`
    background-color: ${getColorForScore({
      theme,
      score: $leadScoreToDisplay,
    })};
    padding: ${theme.space('xxs')};
    font-size: ${theme.fontSize('s')};
    line-height: ${theme.lineHeight('m')};
  `};
`;

const LeadScoreSpan = styled.div<{ $leadScore: number }>(
  ({ theme, $leadScore }) => css`
    align-self: center;
    color: ${getContrastingColor(
      getColorForScore({ theme, score: $leadScore }),
    )};
    white-space: nowrap;
  `,
);

export default LeadScoreDisplayer;
